import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { registerTabs, changeTabs } from '../../../actions/tabs';

function reduxTabs(options, getActiveTab) {
  function withOptions(WrappedComponent) {
    class withRedux extends Component {
      constructor(props, context) {
        super(props, context);

        this.handleTabClick = ::this.handleTabClick;
        this.handleHashChange = ::this.handleHashChange;
        this.findTabByURL = ::this.findTabByURL;
      }

      componentDidMount() {
        this.props.registerTabs(options.tabs, {
          tabList: this.props.tabs,
          activeTab: this.props.activeTab,
          activeTabIndex: this.props.activeTabIndex,
        });

        global.addEventListener('hashchange', this.handleHashChange);
      }

      componentWillUnmount() {
        global.removeEventListener('hashchange', this.handleHashChange);
      }

      // Try to define `this.props.history.push` in upper decorator - bindRouter
      handleTabClick(tab) {
        this.props.changeTabs(options.tabs, tab);
        this.props.history.push(tab.url);
      }

      handleHashChange(event) {
        const tabURL = new URL(event.newURL).hash;
        this.props.changeTabs(options.tabs, this.findTabByURL(tabURL));
      }

      findTabByURL(tabURL) {
        return this.props.tabs.find(tab => tab.url === tabURL) || this.props.tabs[0];
      }

      render() {
        return (
          <WrappedComponent {...this.props} handleTabClick={this.handleTabClick} />
        );
      }
    }

    function mapStateToProps(state, ownProps) {
      let activeTabIndex;

      if (options.tabs in state.tabs) {
        return {
          tabs: state.tabs[options.tabs].tabList,
          activeTab: state.tabs[options.tabs].activeTab,
          activeTabIndex: state.tabs[options.tabs].activeTabIndex,
        };
      }

      const activeTabUrl = getActiveTab(state);
      const [tabList] = ownProps.children;
      const tabs = tabList.props.children.map(tab => ({
        label: tab.props.label,
        heading: tab.props.heading,
        url: tab.props.url,
      }));

      const activeTab = tabs.find(tab => tab.url === activeTabUrl) || tabs[0];
      activeTabIndex = tabs.findIndex(tab => tab.url === activeTabUrl);
      if (!~activeTabIndex) {
        activeTabIndex = 0;
      }

      return {
        tabs,
        activeTab,
        activeTabIndex,
      };
    }

    return compose(
      withRouter,
      connect(mapStateToProps, { registerTabs, changeTabs }),
    )(withRedux);
  }

  return withOptions;
}

export default reduxTabs;
